module.exports = __webpack_public_path__ + "static/bottom-background-mobile-96e28d88d069331f56d767a1199a4614.jpg";